import {
  NetworkData,
  Node,
  Edge,
  NodeTypeFilterSettings,
} from '../types/cytoscape';

const filterEdges = (nodes: Node[], originalEdges: Edge[]): Edge[] => {
  const validNodeIds = new Set(nodes.map((node) => node.id));
  return originalEdges.filter(
    (edge) => validNodeIds.has(edge.source) && validNodeIds.has(edge.target)
  );
};

// ノードタイプによるフィルタリング機能
export const filterGraphByNodeType = (
  data: NetworkData,
  nodeTypeFilters: NodeTypeFilterSettings
): NetworkData => {
  const { nodes = [], edges = [] } = data;

  if (nodes.length === 0 || edges.length === 0) {
    return { nodes: [], edges: [] };
  }

  // すべてのノードタイプが非表示の場合は空のデータを返す
  const allDisabled = Object.values(nodeTypeFilters).every(
    (visible) => !visible
  );
  if (allDisabled) {
    return { nodes: [], edges: [] };
  }

  // 表示対象のノードタイプのみをフィルタリング
  const filteredNodes = data.nodes.filter(
    (node) => nodeTypeFilters[node.nodeType] === true
  );

  // 有効なエッジのみを保持
  const validEdges = filterEdges(filteredNodes, data.edges);

  return {
    nodes: filteredNodes,
    edges: validEdges,
  };
};
